document
  .querySelectorAll(
    ".morphee-audio-tile--icon-media .morphee-audio-tile--icon-media__cta"
  )
  .forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      const item = e.target.closest(".morphee-audio-tile--icon-media");
      const mp3 = item.querySelector("audio");
      const bars = item.querySelector(".bars");

      if (item.classList.contains("active")) {
        // If already active, pause the audio and remove the active state
        mp3.pause();
        item.classList.remove("active");
        bars.style.display = "none";
      } else {
        // Pause any other playing audio and reset their states
        document
          .querySelectorAll(".morphee-audio-tile--icon-media.active")
          .forEach(function (playingItem) {
            playingItem.classList.remove("active");
            playingItem.querySelector("audio").pause();
            playingItem.querySelector(".bars").style.display = "none";
          });

        // Play the selected audio and set it as active
        item.classList.add("active");
        mp3.play();
        bars.style.display = "flex";

        // Add an event listener for when the audio ends
        mp3.addEventListener(
          "ended",
          function () {
            item.classList.remove("active");
            bars.style.display = "none";
          },
          { once: true }
        ); // Use { once: true } to ensure the event is only triggered once per play
      }
    });
  });